module.exports = __webpack_public_path__ + "static/media/collective_barrelbank.cfd6de41.jpg";